export default {
  API:process.env.VUE_APP_ENDPOINT,
  MEDIADOMAIN: 'https://media.uniship.vn',
  SHORT_DATE_FORMAT: "DD-MM-YYYY",
  SHORT_MONTH_FORMAT: "MM-YYYY",
  DATE_FORMAT: "DD/MM/YYYY HH:mm:ss",
  SQL_DATE_FORMAT: "YYYY-MM-DD HH:mm:ss",
  SQL_SHORT_DATE_FORMAT: "YYYY-MM-DD",
  SYSTEM_CONFIG: {
    domain: 'https://uniship.vn',
    firebase_prefix: 'vbimex',
    firebase_storage: 'https://firebasestorage.googleapis.com/v0/b/vbimex-2022.appspot.com/o',
    quick_store_import: false,
    notification_time: 30,
    auto_pack_code: false,
    accountant_order_fee_column: false
  },
  PAGINATION: {
    page: 1,
    itemsPerPage: 20,
    mustSort: true,
    sortDesc: [1],
    sortBy: ["ID"]
  },
  ITEMS_PER_PAGE:{
    'items-per-page-options': [20, 30, 40, 50, 100, 200, 500]
  },
  
  ORDER_TYPE: {
    order: 1,
    deposit: 2,
    payAuth: 3,
    transaction: 4
  },
  ORDER_FEESHIP_TYPES: [
    { value: 0, name: 'Theo Kg' },
    { value: 1, name: 'Theo m3' }
  ],
  ORDER_TYPE_LIST: [
    { value: 1, name: 'Mua hộ' },
    { value: 2, name: 'Ký gửi' }
  ],
  ORDER_STATUS_ENUM: {
    cho_dat_coc: 0,
    huy: 1,
    da_dat_coc: 2,
    cho_bao_gia: 3,
    da_mua_hang: 5,
    dang_den_kho_gui: 16,
    da_nhap_kho_gui: 11,
    dang_ve_kho_nhan: 12,
    da_nhap_kho_nhan: 7,
    cho_thanh_toan: 8,
    da_xuat_kho: 9,
    khieu_nai: 13,
    hoan_thanh:10
  },
  ORDER_STATUS: [
    { value: 1, name: 'Hủy đơn hàng', disabled: false, color: '#000000', textColor: '#ffffff' },
    { value: 3, name: 'Chờ báo giá', disabled: false, color: '#9e5959', textColor: '#ffffff' },
    { value: 0, name: 'Chờ đặt cọc', disabled: false, color: '#DF0101', textColor: '#ffffff' },
    { value: 2, name: 'Đã đặt cọc', disabled: false, color: '#0B610B', textColor: '#ffffff' },
    { value: 5, name: 'Đã mua hàng', disabled: false, color: '#0489B1', textColor: '#ffffff' },
    { value: 16, name: 'Đang đến kho gửi', disabled: false, color: '#F7819F', textColor: '#ffffff' },
    { value: 11, name: 'Đã nhập kho gửi', disabled: false, color: '#FE9A2E', textColor: '#ffffff' },
    { value: 12, name: 'Đang về kho nhận', disabled: false, color: '#FE9A2E', textColor: '#ffffff' },
    { value: 7, name: 'Đã nhập kho nhận', disabled: false, color: '#FE9A2E', textColor: '#ffffff' },
    { value: 9, name: 'Đã xuất kho', disabled: false, color: '#0000FF', textColor: '#ffffff' },
    { value: 13, name: 'Khiếu nại', disabled: false, color: '#D358F7', textColor: '#ffffff' },
    { value: 10, name: 'Hoàn thành', disabled: false, color: '#A4A4A4', textColor: '#ffffff' },
  ],
  ORDER_DEPOSIT_STATUS_ENUM: {
    dang_den_kho_gui: 16,
    da_nhap_kho_gui: 11,
    dang_ve_kho_nhan: 12,
    da_nhap_kho_nhan: 7,
    cho_thanh_toan: 8,
    da_thanh_toan: 9,
    hoan_thanh: 10,
    huy_don_hang: 1
  },
  ORDER_DEPOSIT_STATUS: [
    { value: 1, name: 'Hủy đơn hàng', color: '#000000', textColor: '#ffffff' },
    { value: 16, name: 'Đang đến kho gửi', color: '#F7819F', textColor: '#ffffff' },
    { value: 11, name: 'Đã nhập kho gửi', color: '#FE9A2E', textColor: '#ffffff' },
    { value: 13, name: 'Khiếu nại', color: '#D358F7', textColor: '#ffffff' },
    { value: 12, name: 'Đang về kho nhận', color: '#FE9A2E', textColor: '#ffffff' },
    { value: 7, name: 'Đã nhập kho nhận', color: '#FE9A2E', textColor: '#ffffff' },
    { value: 8, name: 'Chờ thanh toán', color: '#FACC2E', textColor: '#ffffff' },
    { value: 9, name: 'Đã xuất kho', color: '#0000FF', textColor: '#ffffff' },
    { value: 10, name: 'Hoàn thành', color: '#A4A4A4', textColor: '#ffffff' },
  ],
  PAY_SERVICE_STATUS_ENUM: {
    don_huy: 1,
    cho_bao_gia: 2,
    cho_thanh_toan: 3,
    da_thanh_toan: 4,
    hoan_thanh: 5
  },
  PAY_SERVICE_STATUS: [
    { value: 1, name: 'Đơn huỷ', color: '#000000', textColor: '#ffffff' },
    { value: 2, name: 'Chờ báo giá', color: '#F7819F', textColor: '#ffffff' },
    { value: 3, name: 'Chờ thanh toán', color: '#FACC2E', textColor: '#ffffff' },
    { value: 4, name: 'KH đã thanh toán', color: '#FE9A2E', textColor: '#ffffff' },
    { value: 5, name: 'Hoàn thành', color: '#0000FF', textColor: '#ffffff' }
  ],
  PAY_SERVICE_TYPE: [
    { value: 1, name: 'Nội bộ', color: '#000000', textColor: '#ffffff' },
    { value: 0, name: 'Khách hàng', color: '#F7819F', textColor: '#ffffff' },
  ],
  PAY_SERVICE_PAYTYPE: [
    { value: 'bank', name: 'Chuyển khoản ngân hàng' },   
    { value: 'wechat', name: 'Wechat' },   
    { value: 'alipay', name: 'Alipay' }   
  ],
  PAY_AUTHORITY_STATUS: [
    { value: 1, name: 'Đơn huỷ', color: '#000000', textColor: '#ffffff' },
    { value: 2, name: 'Chờ báo giá', name1: 'Chờ cấp TKUQ', color: '#F7819F', textColor: '#ffffff' },
    { value: 3, name: 'Chờ ủy quyền', color: '#FACC2E', textColor: '#ffffff' },
    { value: 4, name: 'Khiếu nại', color: '#D358F7', textColor: '#ffffff' },
    { value: 5, name: 'Đã ủy quyền', color: '#FE9A2E', textColor: '#ffffff' },
    { value: 6, name: 'Hoàn thành', color: '#0000FF', textColor: '#ffffff' }
  ],
  PAY_AUTHORITY_STATUS_ENUM: {
    don_huy: 1,
    cho_bao_gia: 2,
    cho_uy_quyen: 3,
    khieu_nai: 4,
    da_uy_quyen: 5,
    hoan_thanh: 6
  },
  PAY_AUTHORITY_APPROVE: [
    { value: 0, name: 'Chưa xác minh', color: '#000000', textColor: '#ffffff' },
    { value: 1, name: 'Đã xác minh', color: '#0000FF', textColor: '#ffffff' },
  ],
  INTERNAL_FINANCE_TYPES: [
    { value: 1, name: 'Phiếu thu', color: '#000000', textColor: '#ffffff' },
    { value: 2, name: 'Phiếu chi', color: '#000000', textColor: '#ffffff' },
    { value: 3, name: 'Tạm ứng', color: '#000000', textColor: '#ffffff' },
  ],
  INTERNAL_FINANCE_TYPE_ENUM: {
    thu: 1,
    chi: 2,
    ung: 3,
  },
  INTERNAL_FINANCE_STATUS: [
    { value: 2, name: 'Chờ duyệt', color: '#F7819F', textColor: '#ffffff' },
    { value: 3, name: 'Đã duyệt', color: '#FACC2E', textColor: '#ffffff' },
    { value: 4, name: 'Đã giải ngân', color: '#FE9A2E', textColor: '#ffffff' },
    { value: 5, name: 'Hoàn thành', color: '#0000FF', textColor: '#ffffff' },
    { value: 6, name: 'Giải trình', color: '#be0000', textColor: '#ffffff' },
    { value: 99, name: 'Đã hủy', color: '#000000', textColor: '#ffffff' },
  ],
  INTERNAL_FINANCE_STATUS_ENUM: {
    cho_duyet: 2,
    da_duyet: 3,
    giai_ngan: 4,
    hoan_thanh: 5,
    giai_trinh: 6,
    huy: 99,
  },
  VIP_LEVEL: [
    { value: 1, name: '', color: '' },
    { value: 2, name: 'v1', color: '#FFCC80' },
    { value: 3, name: 'v2', color: '#FFB74D' },
    { value: 4, name: 'v3', color: '#FFA726' },
    { value: 5, name: 'v4', color: '#FB8C00' },
    { value: 6, name: 'v5', color: '#F57C00' },
    { value: 7, name: 'v6', color: '#EF6C00' },
  ],
  PACKAGE_STATUS_ENUM: {
    CHUA_PHAT_HANG: 0,
    DANG_TOI_KHO_GUI: 1,
    DA_VE_KHO_GUI: 2,
    DANG_VE_KHO_NHAN: 3,
    DA_VE_KHO_NHAN: 4,
    KH_DA_NHAN: 5
  },
  PACKAGE_STATUS: [
    { value: 0, name: 'Chưa phát hàng', disabled: true, color: 'red', textColor: '#000' },
    { value: 1, name: 'Đang đến kho gửi', disabled: false, color: 'black', textColor: '#FFF' },
    { value: 2, name: 'Đã về kho gửi', disabled: false, color: 'green', textColor: '#FFF' },
    { value: 3, name: 'Đang về kho nhận', disabled: false, color: '#EF6C00', textColor: '#FFF' },
    { value: 4, name: 'Đã về kho nhận', disabled: false, color: 'green', textColor: '#FFF' },
    { value: 5, name: 'Đã giao hàng', disabled: false, color: 'blue', textColor: '#FFF' },
    { value: 13, name: 'Khiếu nại', disabled: false, color: 'purple', textColor: '#FFF' },
  ],
  PACKAGE_STORE_STATE_ENUM: {
    CHUA_CHUAN_BI: 0,
    DA_CHUAN_BI: 1,
  },
  PACKAGE_STORE_STATES: [
    { value: 0, name: 'Chưa chuẩn bị', disabled: false, color: 'red', textColor: '#000' },
    { value: 1, name: 'Đã chuẩn bị', disabled: false, color: 'green', textColor: '#FFF' },
  ],
  BIG_PACKAGE_STATUS_ENUM: {
    DANG_DONG_BAO: 0,
    XUAT_KHO_TQ: 1,
    NHAP_KHO_VN: 2
  },
  BIG_PACKAGE_STATUS: [
    { value: 0, name: 'Đang đóng bao', disabled: true, color: 'red', textColor: '#000' },
    { value: 1, name: 'Xuất kho gửi', disabled: false, color: 'black', textColor: '#FFF' },
    { value: 2, name: 'Nhập kho nhận', disabled: false, color: 'green', textColor: '#FFF' }
  ],
  COMMENT_TYPE: [
    { value: 1, name: 'Công khai', color: '#2EBB32' },
    { value: 2, name: 'Nội bộ', color: '#dc3545' }
  ],
  CUSTOMER_STATUS: {
    InActive: 1,
    Actived: 2,
    Blocked: 3
  },
  CUSTOMER_STATUS_LIST: [
    { value: 1, name: 'Chưa kích hoạt', color: '#808080' },
    { value: 2, name: 'Đã kích hoạt', color: '#0059b3' },
    { value: 3, name: 'Đang bị khóa', color: '#e63900' },
  ],
  RECHARGE_STATUS: {
    Pending: 1,
    Approved: 2,
    Cancel: 3,
    Transferred: 4,
    Cash: 5,
  },
  RECHARGE_STATUS_LIST: [
    { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
    { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
    { value: 3, name: 'Hủy', color: '#e63900', textColor: '#000' },
    // { value: 4, name: 'Chuyển khoản', color: '#00b300', textColor: '#FFF' },
    // { value: 5, name: 'Tiền mặt', color: '#2d8659', textColor: '#FFF' },
  ],
  WITHDRAW_STATUS: {
    Pending: 1,
    Approved: 2,
    Cancel: 3,
    Completed: 4,
  },
  WITHDRAW_STATUS_LIST: [
    { value: 1, name: 'Chờ duyệt', color: '#000000', textColor: '#000' },
    { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
    { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' },
    { value: 4, name: 'Hoàn thành', color: '#2d8659', textColor: '#FFF' },
  ],  
  CONTACT_CARE_ACTIONS: [
    { value: 1, name: 'Cuộc gọi', color: '#dc3545', textColor: '#000' },
    { value: 2, name: 'Trao đổi', color: '#0059b3', textColor: '#FFF' },
    { value: 3, name: 'Cuộc họp', color: '#e63900', textColor: '#000' }
  ],
  CONTACT_CARE_STATUS: [
    { value: 1, name: 'Lên kế hoạch', color: '#F7819F', textColor: '#FFF' },
    { value: 2, name: 'Đã thực hiện', color: '#2d8659', textColor: '#FFF' },
  ],
  CONTACT_OPPORTUNITY_STATUS: [
    { value: 1, name: 'Cơ hội mới', key:'new', color: '#F7819F', textColor: '#FFF' },
    { value: 2, name: 'Đang thực hiện', key:'negotiate', color: '#0059b3', textColor: '#FFF' },
    { value: 3, name: 'Thành công', key:'success', color: '#2d8659', textColor: '#FFF' },
    { value: 4, name: 'Thất bại', key:'failed', color: '#808080', textColor: '#FFF' },
  ],
  CONTACT_OPPORTUNITY: {
    new: 1,
    negotiate: 2,
    success: 3,
    failed: 4
  },
  PAYMENT_TYPE: {
    Deposit: 1,
    Complete: 2,
  },
  PAYMENT_TYPE_LIST: [
    { value: 1, name: 'Đặt cọc', color: '#2d8659', textColor: '#FFF' },
    { value: 2, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
  ],
  PAYMENT_STATUS: {
    DatCoc: 2,
    ThanhToan: 9,
    PhiShip: 10,
    PhiKhac: 11,
    NhanLaiCoc: 12
  },
  PAYMENT_STATUS_LIST: [
    { value: 2, name: 'Đặt cọc', color: '#2d8659', textColor: '#FFF' },
    { value: 9, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
    { value: 10, name: 'Phí ship', color: '#808080', textColor: '#FFF' },
    { value: 11, name: 'Phí khác', color: '#808080', textColor: '#FFF' },
    { value: 12, name: 'Nhận lại cọc', color: '#FFB74D', textColor: '#000' },
  ],
  COMPLAIN_STATUS: {
    Cancel: 4,
    Processing: 2,
    Pending: 1,    
    Done: 3,
  },
  COMPLAIN_STATUS_LIST: [
    { value: 4, name: 'Hủy', color: 'orange' },
    { value: 2, name: 'Đang xử lý', color: 'green' },
    { value: 1, name: 'Chờ xử lý', color: 'red' },
    { value: 3, name: 'Đã xử lý', color: 'blue' }
  ],
  COMPLAIN_METHOD_LIST: [
    { value: 1, name: 'Hoàn tiền', color: 'red' },
    { value: 2, name: 'Hàng hóa thay thế', color: 'blue' }
  ],
  DATA_TYPE: {
    String: 0,
    Number: 1,
    Enum: 2,
    Date: 3,
    Boolean: 4
  },
  LIST_COMPARISON: [
    { name: 'Có chứa', value: 'contain', display: '({0})', dataType: 0 },
    { name: 'Không chứa', value: 'does_not_contain', display: '-({0})', dataType: 0 },
    { name: 'Bằng', value: 's_equal', display: '= {0}', dataType: 0 },
    { name: 'Khác', value: 's_does_not_equal', display: '!= {0}', dataType: 0 },
    { name: 'Bằng', value: 'equal', display: '= {0}', dataType: 1 },
    { name: 'Khác', value: 'does_not_equal', display: '!= {0}', dataType: 1 },
    { name: 'Lớn hơn', value: 'greater_than', display: '> {0}', dataType: 1 },
    { name: 'Lớn hơn hoặc bằng', value: 'greater_than_or_equal', display: '>= {0}', dataType: 1 },
    { name: 'Nhỏ hơn', value: 'less_than', display: '< {0}', dataType: 1 },
    { name: 'Nhỏ hơn hoặc bằng', value: 'less_than_or_equal', display: '<= {0}', dataType: 1 },
    { name: 'Bằng', value: 'in', display: '= [{0}]', dataType: 2 },
    { name: 'Khác', value: 'not_in', display: '!= [{0}]', dataType: 2 },
    { name: 'Bằng', value: 'd_equal', display: '= {0}', dataType: 3 },
    { name: 'Khác', value: 'd_does_not_equal', display: '!= {0}', dataType: 3 },
    { name: 'Lớn hơn', value: 'd_greater_than', display: '> {0}', dataType: 3 },
    { name: 'Lớn hơn hoặc bằng', value: 'd_greater_than_or_equal', display: '>= {0}', dataType: 3 },
    { name: 'Nhỏ hơn', value: 'd_less_than', display: '< {0}', dataType: 3 },
    { name: 'Nhỏ hơn hoặc bằng', value: 'd_less_than_or_equal', display: '<= {0}', dataType: 3 },
    { name: 'Bằng', value: 'equal', display: '= {0}', dataType: 4 },
  ],
  ROLE_TYPE: {
    Admin: 1,
    Manager: 2,
    Purchase: 4,
    CustomerService: 8,
    InteralControl: 16,
    StoreVN: 32,
    StoreTQ: 64,
    Payment: 128,
    Config: 256,
    StoreTQ2: 512,
    PayService: 1024,
    Complain: 2048
  },
  ROLES: [
    { value: 1, name: 'Admin'},
    // { value: 2, name: 'Quản lý'},
    { value: 4, name: 'Mua hàng'},
    { value: 8, name: 'Chăm sóc khách hàng'},
    // { value: 16, name: 'Interal Control'},
    { value: 32, name: 'Kho Việt Nam'},
    { value: 64, name: 'Kho Trung Quốc'},
    { value: 128, name: 'Kế toán'},
    { value: 256, name: 'Cấu hình'},
    { value: 1024, name: 'Thanh toán'},
    { value: 2048, name: 'Quản lý khiếu nại'},
  ],
  TRADE_TYPE: [
    { value: 1, name: 'Đặt cọc'},
    { value: 2, name: 'Nhận lại tiền đặt cọc' },
    { value: 3, name: 'Thanh toán hóa đơn' },
    { value: 4, name: 'Nạp tiền' },
    { value: 5, name: 'Rút tiền' },
    { value: 6, name: 'Hủy lệnh rút tiền' },
    { value: 7, name: 'Xử lý khiếu nại' },
    { value: 8, name: 'Hủy lệnh chuyển tiền' },
  ],
  SIGNAL_TYPE: [
    { value: 0, name: 'Chưa ký nhận'},
    { value: 1, name: 'Đã ký nhận' },
    { value: 3, name: 'Kiểm hàng' },
    { value: 2, name: 'Khác' }
    
  ],
  RECHARGE_TYPE: {
    Vietinbank: 1,
    Vietcombank: 2,
    BIDV: 3,
    AGRIBANK: 4,
    Techcombank: 5,
    MBBank: 6,
    VIB: 7,
    ACB: 8,
    MBBankVan: 9,
    Cash: 90,
    COD: 91,
    Yuan: 92,
    Yuan2: 94,
    ACBCTY: 95,
    ACBCTY247: 96,
  },
  RECHARGE_METHODS: [
    { value: 1, name: 'Vietinbank'},
    { value: 2, name: 'Vietcombank'},
    // { value: 3, name: 'BIDV'},
    // { value: 4, name: 'AGRIBANK'},
    { value: 5, name: 'Techcombank'},
    { value: 6, name: 'MBBank'},
    { value: 7, name: 'VIB'},
    { value: 8, name: 'ACB'},
    { value: 9, name: 'MBBank Van'},
    { value: 90, name: 'Tiền mặt'},
    { value: 91, name: 'MB CTY'},
    { value: 95, name: 'ACB CTY'},
    { value: 96, name: 'ACB CTY 247'},
    { value: -1, name: 'Ví ảo'},
  ],
  MONEY_SOURCES: [
    { value: 1, name: 'Vietinbank' },
    { value: 2, name: 'Vietcombank' },
    // { value: 3, name: 'BIDV' },
    // { value: 4, name: 'AGRIBANK' },
    { value: 5, name: 'Techcombank'},
    { value: 6, name: 'MBBank'},
    { value: 7, name: 'VIB'},
    { value: 8, name: 'ACB'},
    { value: 9, name: 'MBBank Van'},
    { value: 90, name: 'Tiền mặt' },
    { value: 91, name: 'MB CTY' },
    { value: 92, name: 'Yuan1' },
    { value: 94, name: 'Yuan2' },
    { value: 95, name: 'ACB CTY' },
    { value: 96, name: 'ACB CTY 247' },
    { value: 93, name: 'System' },
    { value: 99, name: 'Khác'}
    
  ],
  MONEY_COMMANDS: [
    { value: 1, name: 'Nạp tệ', type: 0, pay: 1 },
    { value: 2, name: 'Thu khác', type: 0, pay: 1 },
    { value: 3, name: 'Shop hoàn KN', type: 0, pay: 1 },
    { value: 4, name: 'Chi mua tệ', type: 1, pay: 1 },
    { value: 5, name: 'Chi phí nhân công', type: 1, pay: 1 },
    { value: 6, name: 'Thanh toán đối tác VCQT', type: 1, pay: 1 },
    { value: 7, name: 'Thanh toán đối tác VCVN', type: 1, pay: 1},
    { value: 8, name: 'Chi phí Marketing', type: 1, pay: 1 },
    { value: 9, name: 'Chi phí Quản lý', type: 1, pay: 1},
    { value: 10, name: 'Chi phí bán hàng', type: 1, pay: 1 },
    { value: 11, name: 'Chi phí khác', type: 1, pay: 1 },
    { value: 90, name: 'Chuyển tiền nội bộ', type: -1 },
    { value: 91, name: 'Khách nạp ví', type: 0},
    { value: 92, name: 'Khách rút tiền', type: 1 },
    { value: 93, name: 'Hủy nạp ví', type: 1},
    { value: 94, name: 'Hủy lệnh rút tiền', type: 0},
  ],
  PAYMENTORDER_STATUS: {
    Unpaid: 0,
    Paid: 1,
  },
  PAYMENTORDER_STATUS_LIST: [
    { value: 0, name: 'Chưa thanh toán', color: '#e63900', textColor: '#FFF' },
    { value: 1, name: 'Đã thanh toán', color: '#0059b3', textColor: '#FFF' },
  ],
  TUIKUAN_STATUS: {
    cho_xu_ly: 0,
    da_xu_ly: 1,
  },
  TUIKUAN_STATUS_LIST: [
    { value: 0, name: 'Chờ xử lý', color: '#e63900', textColor: '#FFF' },
    { value: 1, name: 'Đã xử lý (Tăng TKKH+PT)', color: '#0059b3', textColor: '#FFF' },
  ],
  PRICES_STATUS: {
    chua_kich_hoat: 0,
    da_kich_hoat: 1,
  },
  PRICES_STATUS_LIST: [
    { value: 0, name: 'Chưa kích hoạt', color: '#e63900', textColor: '#FFF' },
    { value: 1, name: 'Đã kích hoạt', color: '#0059b3', textColor: '#FFF' },
  ],
  PRICES_GLOBAL: {
    private: 0,
    public: 1,
  },
  PRICES_GLOBAL_LIST: [
    { value: 0, name: 'Giá riêng', color: '#e63900', textColor: '#FFF' },
    { value: 1, name: 'Giá chung', color: '#0059b3', textColor: '#FFF' },
  ],
  FLAG_TYPE: {
    cham_phat_hang: 1,
    cham_nhap_kho_tq: 2,
    cham_nhap_kho_vn: 3,
    cham_mua_hang: 4,
    cham_xuat_kho_tq: 5,
    cham_bao_gia: 6,
    cham_thanh_toan: 7,
  },
  FLAG_TYPE_LIST: [
    { value: 1, name: 'Chậm phát hàng' },
    { value: 2, name: 'Chậm nhập kho gửi' },
    { value: 3, name: 'Chậm nhập kho nhận' },
    { value: 4, name: "Chậm mua hàng" },
    { value: 5, name: "Chậm xuất kho gửi" },
    { value: 6, name: "Chậm báo giá" },
    { value: 7, name: "Chậm thanh toán" },
  ],
  TAG_TYPE_LIST: [
    { value: 0, name: 'Nội bộ' },
    { value: 1, name: 'Khách hàng' },
  ],
  PAYMENT_REQUEST_STATUS_ENUM: {
    nhap: 0,
    chua_xu_ly: 1,
    duoc_xuat_kho: 2,
    hoan_thanh: 3,
    xuat_thieu_kien: 4
  },
  PAYMENT_REQUEST_STATUS: [
    { value: 0, name: 'Nháp', color: '#535353', textColor: '#000' },
    { value: 1, name: 'Chờ xử lý', color: '#d9534f', textColor: '#000' },
    { value: 2, name: 'Được xuất kho', color: 'green', textColor: '#FFF' },
    { value: 3, name: 'Hoàn thành', color: 'blue', textColor: '#FFF' },
    { value: 4, name: 'Xuất thiếu kiện', color: '#e87235', textColor: '#FFF' }
  ],
  EXPORT_RECEIPT_STATUS_ENUM: {
    phieu_nhap: 1,
    da_chuan_bi: 2,
    hoan_thanh: 3
  },
  EXPORT_RECEIPT_STATUS: [
    { value: 1, name: 'Phiếu nháp', color: '#d9534f', textColor: '#000' },
    { value: 2, name: 'Đã chuẩn bị hàng', color: 'green', textColor: '#FFF' },
    { value: 3, name: 'Hoàn thành', color: 'blue', textColor: '#FFF' }
  ],
  STORE_TYPE_LIST: [ 
    { name: "Nhập khẩu", value: 1 },
    { name: "Xuất khẩu", value: 2 },
    { name: "TMĐT", value: 3 },
    { name: "Tất cả", value: 0 }
  ],
  PRICE_TYPE_ENUM: {
    don_thuong: 1,
    gui_nguoc: 2
  },
  PRICE_TYPE_LIST: [ 
    { name: "Nhập khẩu", value: 1 }, 
    { name: "Xuất khẩu", value: 2 },
    { name: "TMĐT", value: 3 }
  ],
  SMS_TYPE_ENUM: {
    thanh_cong: 1,
    that_bai: 2
  },
  SMS_TYPE_LIST: [ 
    { name: "Thành công", value: 1, color: '#0059b3' }, 
    { name: "Thất bại", value: 2, color: '#d9534f' }
  ],
  WARNING_STATUS_ENUM: {
    chua_xu_ly: 1,
    dang_xu_ly: 2,
    hoan_thanh: 3
  },
  WARNING_STATUS: [
    { name: "Chưa xử lý", value: 1, color: '#e63900' }, 
    { name: "Đang xử lý", value: 2, color: '#e87235' },
    { name: "Hoàn thành", value: 3, color: 'green' }
  ],
  GUARANTEE_TYPE: [
    { name: "Giá trị hàng", value: 0, color: '#e63900' }, 
    { name: "Phí vận chuyển", value: 1, color: '#e87235' }
  ],
  CONTACT_STATE: [
    { value: 0, name: '' },
    { value: 1, name: 'Cô đơn' }
  ],
  PACKAGE_STATE: [
    { value: 1, name: 'Đã khớp đơn' },
    { value: 2, name: 'Kiện vô chủ' },
    { value: 3, name: 'Cần khớp đơn' }
  ],
  VOUCHER_STATUS: [
    { value: 0, name: 'Chưa kích hoạt' },
    { value: 1, name: 'Đã kích hoạt' },
    { value: 2, name: 'Đã huỷ' },
  ],
  VOUCHER_STATE: [
    { value: 0, name: 'Chưa sử dụng' },
    { value: 1, name: 'Đã sử dụng' }
  ],
  FEE_LIST: [
    {
      id: 1,
      enabled: 0,
      text: 'Phí vận chuyển quốc tế'
    },
    {
        id: 2,
        enabled: 0,
        text: 'Phí vận chuyển nội địa VN'
    },
    {
      id: 3,
      enabled: 0,
      text: 'Phí bảo hiểm'
    },
    {
      id: 4,
      enabled: 0,
      text: 'Phí kiểm đếm'
    },
    {
      id: 5,
      enabled: 0,
      text: 'Phí gia cố'
    },
    {
      id: 6,
      enabled: 0,
      text: 'Phí dịch vụ mua hàng'
    },
    {
      id: 7,
      enabled: 0,
      text: 'Tiền hàng giao dịch'
    },
    {
      id: 8,
      enabled: 0,
      text: 'Phụ phí khác'
    }
  ],
  CHECK_BIGPACKAGE_STATUS: [
    { value: 0, name: 'Nháp', color: '#929292' },
    { value: 1, name: 'Đang đối soát', color: '#e63900' },
    { value: 2, name: 'Hoàn thành', color: '#0059b3' },
  ],
  CHECK_BIGPACKAGE_STATE: [ 
    { value: 0, name: "Hàng chưa về", disabled: true }, 
    { value: 1, name: "Chờ xử lý", disabled: true }, 
    { value: 2, name: "Đang xử lý", disabled: false }, 
    { value: 3, name: "Hoàn thành", disabled: true } 
  ],
  CANCEL_REASON: [ 
    { value: 1, name: "NCC/Shop không có hàng (thời gian chuẩn bị quá lâu)", disabled: false }, 
    { value: 2, name: "Đổi ý không còn nhu cầu", disabled: false },
    { value: 8, name: "Giá cao so với kỳ vọng", disabled: false },
    { value: 9, name: "Sản phẩm Vbimex BG không đạt yêu cầu", disabled: false },
    { value: 3, name: "Lên đơn nhầm", disabled: false },
    { value: 4, name: "Thay đổi số lượng, chủng loại, shop", disabled: false },
    { value: 5, name: "Hàng hóa không đạt, yêu cầu trả lại NCC", disabled: false },
    { value: 6, name: "Vận chuyển Vbimex không kịp tiến độ", disabled: false },
    { value: 7, name: "Lý do khác", disabled: false },
    { value: 10, name: "NV hỗ trợ thiếu nhiệt tình", disabled: true },
  ],
  CHECK_BIGPACKAGE_TYPE: [
    { value: 0, name: 'Kho trung chuyển', color: '#929292' },
    { value: 1, name: 'Kho nhận', color: '#e63900' },
  ],
  FEE_SHIP_TYPES: [
    { value: 0, name: 'Công ty trả', color: '#929292' },
    { value: 1, name: 'Miễn ship', color: '#e63900' },
    { value: 2, name: 'Khách trả', color: '#0059b3' }
  ],
  ZNS_STATUS: [
    { value: 0, name: 'Chưa gửi', color: '#929292' },
    { value: -1, name: 'Đang gửi', color: '#02740e' },
    { value: 1, name: 'Đã gửi', color: '#0059b3' },
    { value: 2, name: 'Gửi lỗi', color: '#e63900' },
    { value: 3, name: 'Đã hủy', color: '#757575' }
  ],
  ZNS_CAMPAIGN_STATUS: [
    { value: 1, name: 'Đang chạy', color: '#02740e' },
    { value: 2, name: 'Tạm dừng', color: '#f9a825' },
    { value: 3, name: 'Đã hủy', color: '#757575' },
    { value: 4, name: 'Hoàn thành', color: '#0059b3' }
  ],
  NOTI_TYPE: [
    { value: 0, name: 'Chung', color: '#323030' },
    { value: 1, name: 'Công khai', color: '#02740e' },
    { value: 2, name: 'Nội bộ', color: '#e63900' }
  ],
  OFFICIAL_LIST: [
    { value: 1, name: "CN" },
    { value: 0, name: "TN" }
  ]
};
